export class UserService {
  public userId: number;
  public serviceId: number;
  public validationDistribution?: boolean;
  public refuserModification?: boolean;
  public refuserCreationEntrant?: boolean;
  public refuserCreationSortant?: boolean;
  public refuserAjoutDistribution?: boolean;
  public cacherStatutsMultiples?: boolean;
  public cacherFichiers?: boolean;
  public addMailEntrant?: boolean;
  public addMailSortant?: boolean;
  public addMailInterne?: boolean;
  public selectable: boolean;
  public interdireRepondreDocument?: boolean;
  public refuserAjoutFichier?: boolean;
  public refuserAjoutVersionFichier?: boolean;
  public refuserModificationFichier?: boolean;
  public refuserSuppressionFichier?: boolean;
  public refuserVisualisationFichier?: boolean;
  public refuserVisualisationVersionsFichiers?: boolean;
  public repondreAuNomDeQq?: boolean;
  public responsableService?: boolean;
  public validationEtapes?: number[];
}
